import { Paper } from '@mui/material';
import { CustomPaperStyles } from '../components/TrfScreens/Main/FormLandingStyles';
import { RNR_SECS_PAST_SLOT, TIME_SETTINGS_NOSECOND } from '../components/VialMapping/constants';

export function EncodeQueryData(data) {
  const ret = [];
  for (const d in data) {
    if (data[d] !== undefined) {
      ret.push(`${encodeURIComponent(d)}=${encodeURIComponent(data[d])}`);
    }
  }
  return ret.join('&');
}

/* eslint-disable react/prop-types */
export const CustomPaper = ({ children, ...paperProps }) => (
  <Paper elevation={2} sx={CustomPaperStyles} {...paperProps} className="customAutoComplete">
    {children}
  </Paper>
);

export function MakeRandomString(length) {
  let i;
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (i = 0; i < length; i += 1) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export function capitalizeFirstLetters(sentence) {
  const words = sentence.split(' ');
  const capitalizedWords = words.map(word => {
    const firstLetter = word.charAt(0).toUpperCase();
    const restOfWord = word.slice(1);
    return firstLetter + restOfWord;
  });
  return capitalizedWords.join(' ');
}

export function b64toBlob(dataURI) {
  const byteString = atob(dataURI.split(',')[1]);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i += 1) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], { type: 'image/jpeg' });
}

export function validateBarcode(subject) {
  return /^[a-zA-Z0-9_]*$/.test(subject);
}

export function useQuery(queryString, searchParam) {
  return new URLSearchParams(queryString).get(searchParam);
}

// a rough split for barcoding library switch
// if epoch times last digit is <= 8, then use dynamosoft
// else fallback to stritch
export function splitBarcodeByEpochPercentage() {
  const currentEpochTimeInSeconds = Math.floor(new Date().getTime() / 1000);
  const epochTimeString = currentEpochTimeInSeconds.toString();
  const lastDigit = epochTimeString.charAt(epochTimeString.length - 1);

  if (lastDigit < 8) {
    return 'dynamosoft';
  }
  return 'dynamosoft';
}

export function formatTestArray(testArray) {
  const maxLength = 3;
  if (testArray) {
    const remainingTests = testArray.length - maxLength;
    if (remainingTests > 0) {
      const firstTwoTests = testArray.slice(0, maxLength).join(', ');
      return `${firstTwoTests} & ${remainingTests} other tests`;
    }
    return testArray.join(', ');
  }
}

export function getRequestCityFromId(reqId) {
  return String(reqId).substring(0, 3);
}

export function getUintFromRequestId(reqId) {
  return Number(String(reqId).substring(3));
}

export function removeDuplicatesObjectArray(arr, prop) {
  const seen = {}; // To keep track of unique values
  return arr.filter((item) => {
    const value = item[prop];
    if (!Object.prototype.hasOwnProperty.call(seen, value)) {
      seen[value] = true;
      return true; // Include the first occurrence
    }
    return false; // Exclude duplicates
  });
}

export function removeDuplicatesStringArray(arr) {
  return [...new Set(arr)];
}

export function getFormatDateLabel(inputDateTime) {
  const inputDate = new Date(inputDateTime);
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);
  const options = { month: 'long', day: 'numeric' };
  switch (true) {
    case inputDate.toDateString() === today.toDateString():
      return 'Today';
    case inputDate.toDateString() === tomorrow.toDateString():
      return 'Tomorrow';
    default:
      return inputDate.toLocaleDateString(undefined, options);
  }
}

export function getFormatTime(inputDateTime) {
  const inputDate = new Date(inputDateTime);
  const formattedTime = inputDate.toLocaleTimeString([], {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  }).toUpperCase();
  return formattedTime;
}

export function getLastFourDigitsOfRequestId(requestId) {
  return String(requestId).slice(-4);
}

export function getTimerDuration(utc_time) {
  const now = new Date();
  const utcTime = new Date(utc_time);
  const timeDifference = utcTime - now;
  const minutesUntilTime = Math.floor(timeDifference / (1000 * 60)) + (RNR_SECS_PAST_SLOT / 60) + 1;
  const secondsUntilTime = Math.floor(timeDifference / 1000) + RNR_SECS_PAST_SLOT + 1;
  const seconds = Math.floor(secondsUntilTime % 60);
  if (minutesUntilTime <= 0) {
    return [0, 0, 0];
  }
  return [0, 0, seconds];
}

export const formatTimestampForCallStatus = (timestamp) => {
  const utcDate = new Date(timestamp);
  return utcDate.toLocaleString('en-IN', TIME_SETTINGS_NOSECOND);
};

export async function resetCmp() {
  try {
    // Clear cache storage
    const cacheKeys = await caches.keys();
    await Promise.all(cacheKeys.map((cacheName) => caches.delete(cacheName)));
    // Clear indexedDB (IDB)
    const dbNames = await indexedDB.databases();
    await Promise.all(dbNames.map((db) => indexedDB.deleteDatabase(db.name)));
    // Clear other local storage or data as needed
    localStorage.clear();
    // Clear cookies
    // Clear cookies
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i += 1) {
      const cookie = cookies[i];
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    }
    // Unregister service workers
    const registrations = await navigator.serviceWorker.getRegistrations();
    for (const registration of registrations) {
      // eslint-disable-next-line
      await registration.unregister();
    }
    console.log('Website data cleared successfully.');
  } catch (error) {
    console.error('Error clearing website data:', error);
  }
}

export function generateBarcodeName(b) {
  const filename = `vial_${b}_${new Date()
    .toLocaleDateString()
    .replaceAll('/', '_')}_${MakeRandomString(7)}`;
  return filename;
}
